module.exports = __webpack_public_path__ + "img/checked_icon.5408a4b4.svg";